// Representative PAN-India partner network (deterministic generator).
// Names/locations are indicative and generated for showcase purposes.

function mulberry32(a) {
  return function () {
    a |= 0; a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const GEN_CATEGORIES = [
  "Super Stockist", "Wholesaler", "Dealer", "Booking Agent", "Civil Contractor", "Supplier",
];
// "Elite Super Stockist" is an exclusive designation held only by the featured firms below.
export const CATEGORIES = ["Elite Super Stockist", ...GEN_CATEGORIES];

const STATES = [
  ["Maharashtra", ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"]],
  ["Tamil Nadu", ["Chennai", "Coimbatore", "Madurai", "Trichy", "Salem"]],
  ["Uttar Pradesh", ["Lucknow", "Kanpur", "Noida", "Ghaziabad", "Varanasi"]],
  ["Karnataka", ["Bengaluru", "Mysuru", "Hubli", "Mangaluru", "Belagavi"]],
  ["Gujarat", ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"]],
  ["West Bengal", ["Kolkata", "Howrah", "Siliguri", "Durgapur", "Asansol"]],
  ["Rajasthan", ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"]],
  ["Telangana", ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar"]],
  ["Andhra Pradesh", ["Visakhapatnam", "Vijayawada", "Guntur", "Tirupati"]],
  ["Madhya Pradesh", ["Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain"]],
  ["Kerala", ["Kochi", "Thiruvananthapuram", "Kozhikode", "Thrissur"]],
  ["Bihar", ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur"]],
  ["Odisha", ["Bhubaneswar", "Cuttack", "Rourkela", "Sambalpur"]],
  ["Punjab", ["Ludhiana", "Amritsar", "Jalandhar", "Patiala"]],
  ["Haryana", ["Gurugram", "Faridabad", "Panipat", "Hisar"]],
  ["Delhi", ["New Delhi", "Dwarka", "Rohini", "Okhla"]],
  ["Jharkhand", ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro"]],
  ["Chhattisgarh", ["Raipur", "Bhilai", "Bilaspur", "Korba"]],
  ["Assam", ["Guwahati", "Dibrugarh", "Silchar", "Jorhat"]],
  ["Uttarakhand", ["Dehradun", "Haridwar", "Haldwani", "Rudrapur"]],
  ["Himachal Pradesh", ["Shimla", "Solan", "Baddi", "Mandi"]],
  ["Jammu & Kashmir", ["Jammu", "Srinagar", "Udhampur"]],
  ["Goa", ["Panaji", "Margao", "Vasco"]],
  ["Puducherry", ["Puducherry"]],
  ["Chandigarh", ["Chandigarh"]],
  ["Arunachal Pradesh", ["Itanagar", "Naharlagun"]],
  ["Tripura", ["Agartala"]],
  ["Meghalaya", ["Shillong"]],
  ["Manipur", ["Imphal"]],
  ["Nagaland", ["Kohima", "Dimapur"]],
];

const PREFIX = [
  "Shree", "Sri", "Maa", "Balaji", "Jai", "New", "National", "United", "Royal", "Om",
  "Sai", "Ganpati", "Laxmi", "Krishna", "Annapurna", "Bharat", "Metro", "Prime", "Star",
  "Ashirwad", "Vishwakarma", "Trimurti", "Ganesh", "Hanuman", "Deccan", "Capital", "Everest",
  "Gateway", "Pioneer", "Sunrise", "Kohinoor", "Sagar", "Aditya", "Vardhman", "Concord",
];

const CORE = [
  "Steel", "Cement", "Build", "Infra", "Trading", "Enterprises", "Agencies", "Corporation",
  "Sales", "Materials", "Buildmart", "Hardware", "Associates", "Ispat", "Nirman", "Constro",
];

const SUFFIX = {
  "Super Stockist": ["Distributors", "Stockists", "Trading Co."],
  "Wholesaler": ["Wholesale", "Traders", "Trading Co."],
  "Dealer": ["Traders", "Sales", "& Sons"],
  "Booking Agent": ["Marketing", "Associates", "Ventures"],
  "Civil Contractor": ["Constructions", "Infra", "Builders", "Projects"],
  "Supplier": ["Suppliers", "Enterprises", "Sourcing"],
};

const rng = mulberry32(20260808);
const pick = (arr) => arr[Math.floor(rng() * arr.length)];

function generate(perCategory = 100) {
  const rows = [];
  const seen = new Set();
  let id = 1;
  for (const category of GEN_CATEGORIES) {
    let made = 0, guard = 0;
    while (made < perCategory && guard < perCategory * 40) {
      guard++;
      const [state, cities] = STATES[Math.floor(rng() * STATES.length)];
      const city = cities[Math.floor(rng() * cities.length)];
      const name = `${pick(PREFIX)} ${pick(CORE)} ${pick(SUFFIX[category])}`;
      const key = `${name}|${city}`;
      if (seen.has(key)) continue;
      seen.add(key);
      rows.push({
        id: id++,
        name,
        category,
        city,
        state,
        since: 1996 + Math.floor(rng() * 27), // 1996–2022
        verified: rng() > 0.12,
      });
      made++;
    }
  }
  return rows;
}

// Elite Super-Stockists — the sole appointed distributors for Cement, Steel TMT Bars
// & related material in their regions (licensed 2026 by special resolution).
// Elite Super-Stockist — exclusive appointed distributor (gold badge, featured).
const ELITE_FIRMS = [
  {
    name: "Divinity Spaces LLP & Zeus Constructions",
    unit: "Proprietorship",
    scope: "Cement, Steel TMT Bars & related material",
    licensed: "Licensed 2026 · by special resolution",
    coverage: { "Karnataka": "Bengaluru", "Goa": "Panaji" },
  },
];

// Named super-stockists — normal designation, richer detail than generated rows.
const NAMED_STOCKISTS = [
  {
    name: "RealtyF5 Matrix Global",
    unit: "Unit of Maa Baglamukhi Professionals Pvt. Ltd.",
    trade: "RealtyF5 Matrix Global",
    scope: "Cement, Steel TMT Bars & related material",
    coverage: { "Himachal Pradesh": "Nalagarh", "Punjab": "Ludhiana", "Haryana": "Gurugram", "Jammu & Kashmir": "Jammu" },
  },
];

let _namedId = 1;
const expandFirms = (firms, category, opts) =>
  firms.flatMap((f) =>
    Object.entries(f.coverage).map(([state, city]) => ({
      id: `named-${_namedId++}`,
      name: f.name,
      unit: f.unit || null,
      trade: f.trade || null,
      scope: f.scope || null,
      licensed: f.licensed || null,
      address: f.address || null,
      category,
      city,
      state,
      since: 2026,
      verified: true,
      ...opts,
    }))
  );

const FEATURED_PARTNERS = expandFirms(ELITE_FIRMS, "Elite Super Stockist", { featured: true, elite: true });
const NAMED_PARTNERS = expandFirms(NAMED_STOCKISTS, "Super Stockist", { featured: false, elite: false });

export const PARTNERS = [...FEATURED_PARTNERS, ...NAMED_PARTNERS, ...generate(100)];


export const NETWORK_STATS = {
  total: PARTNERS.length,
  states: new Set(PARTNERS.map((p) => p.state)).size,
  categories: CATEGORIES.length,
  verified: PARTNERS.filter((p) => p.verified).length,
  earliest: Math.min(...PARTNERS.map((p) => p.since)),
};

export const ALL_STATES = Array.from(new Set(PARTNERS.map((p) => p.state))).sort();

// Approximate geographic centroids [lng, lat] used to plot the interactive map.
export const STATE_COORDS = {
  "Maharashtra": [74.5, 19.4],
  "Tamil Nadu": [78.6, 11.1],
  "Uttar Pradesh": [80.9, 26.8],
  "Karnataka": [76.2, 14.5],
  "Gujarat": [71.6, 22.6],
  "West Bengal": [87.9, 23.6],
  "Rajasthan": [74.2, 26.6],
  "Telangana": [79.0, 17.9],
  "Andhra Pradesh": [80.0, 15.9],
  "Madhya Pradesh": [78.0, 23.5],
  "Kerala": [76.3, 10.2],
  "Bihar": [85.7, 25.7],
  "Odisha": [84.5, 20.5],
  "Punjab": [75.5, 31.0],
  "Haryana": [76.4, 29.1],
  "Delhi": [77.1, 28.6],
  "Jharkhand": [85.4, 23.6],
  "Chhattisgarh": [82.0, 21.3],
  "Assam": [92.8, 26.2],
  "Uttarakhand": [79.0, 30.1],
  "Himachal Pradesh": [77.3, 31.9],
  "Jammu & Kashmir": [75.3, 33.6],
  "Goa": [74.1, 15.4],
  "Puducherry": [79.8, 11.9],
  "Chandigarh": [76.8, 30.7],
  "Arunachal Pradesh": [94.4, 28.0],
  "Tripura": [91.7, 23.7],
  "Meghalaya": [91.4, 25.5],
  "Manipur": [93.9, 24.7],
  "Nagaland": [94.3, 26.1],
};

// Per-state aggregates for the map (count, verified, top city, coords).
export const STATE_STATS = (() => {
  const map = new Map();
  for (const p of PARTNERS) {
    const s = map.get(p.state) || { state: p.state, count: 0, verified: 0, cities: {} };
    s.count += 1;
    if (p.verified) s.verified += 1;
    s.cities[p.city] = (s.cities[p.city] || 0) + 1;
    map.set(p.state, s);
  }
  const rows = Array.from(map.values()).map((s) => ({
    state: s.state,
    count: s.count,
    verified: s.verified,
    topCity: Object.entries(s.cities).sort((a, b) => b[1] - a[1])[0]?.[0],
    coords: STATE_COORDS[s.state] || null,
  }));
  return rows.filter((r) => r.coords);
})();

export const MAX_STATE_COUNT = Math.max(...STATE_STATS.map((s) => s.count));

// Rotating spotlight: most-established verified firms, one per state for spread.
export const SPOTLIGHT_PARTNERS = (() => {
  const perState = new Map();
  for (const p of PARTNERS.filter((x) => x.verified).sort((a, b) => a.since - b.since)) {
    if (!perState.has(p.state)) perState.set(p.state, p);
  }
  return Array.from(perState.values()).sort((a, b) => a.since - b.since).slice(0, 14);
})();
